"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.input = void 0;
var react_1 = require("@emotion/react");
var Input_component_1 = require("@/components/common/Input/Input.component");
var fonts_1 = require("./fonts");
exports.input = {
    size: (_a = {},
        _a[Input_component_1.InputSize.xs] = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n      padding: 0.8rem 1.2rem;\n    "], ["\n      ", ";\n      padding: 0.8rem 1.2rem;\n    "])), fonts_1.fonts.regular13),
        _a[Input_component_1.InputSize.sm] = (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", ";\n      padding: 0.8rem 1.2rem;\n    "], ["\n      ", ";\n      padding: 0.8rem 1.2rem;\n    "])), fonts_1.fonts.regular15),
        _a[Input_component_1.InputSize.md] = (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      ", ";\n      padding: 1.2rem 1.4rem;\n    "], ["\n      ", ";\n      padding: 1.2rem 1.4rem;\n    "])), fonts_1.fonts.regular15),
        _a),
};
var templateObject_1, templateObject_2, templateObject_3;
